const awsmobile = {
    "aws_project_region": import.meta.env.VITE_AWS_PROJECT_REGION,
    "aws_cognito_region": import.meta.env.VITE_AWS_COGNITO_REGION,
    "aws_user_pools_id": import.meta.env.VITE_AWS_USER_POOLS_ID,
    "aws_user_pools_web_client_id": import.meta.env.VITE_AWS_USER_POOLS_WEB_CLIENT_ID,
    "oauth": {
        "domain": import.meta.env.VITE_AWS_COGNITO_OAUTH_DOMAIN,
        "scope": [
            "email",
            "openid",
            "phone"
        ],
        "redirectSignIn": import.meta.env.VITE_AWS_COGNITO_REDIRECT_SIGN_IN,
        "redirectSignOut": import.meta.env.VITE_AWS_COGNITO_REDIRECT_SIGN_OUT,
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};

export default awsmobile; 